<template>
    <div class="documents">
        <b-modal no-close-on-backdrop title="Preview Document" class="modal-success" v-model="previewDlg" ok-variant="success" :ok-only="true" ok-title="Close" size="lg" @ok="previewDlg=false">
            <b-container fluid>
                <template v-if="mimeDoc && mimeDoc == 'application/pdf'">
                    <h1>PREVIEW PDF!!!! {{ link }}</h1>
                </template>
                <template v-else-if="mimeDoc && mimeDoc == 'image/jpeg'">
                    <img :src="link" alt="preview" style="width: 100%; height: 100%;">
                </template>
                <template v-else >
                    <h1>PREVIEW OTHER !!!! {{ link }}</h1>
                </template>
            </b-container>
        </b-modal>
        <b-modal no-close-on-backdrop title="Add Document" class="modal-success" v-model="addFileDlg" ok-variant="success" :ok-only="false" ok-title="Save" size="lg" @ok="onSubmitDocument">
            <b-container fluid>
                <b-form @submit.prevent="onSubmitDocument" @reset="onResetIssue">
                    <b-form-file v-model="file" :state="Boolean(file)" placeholder="Choose a PDF/JPG/ZIP file or drop it here..." drop-placeholder="Drop PDF/JPG/ZIP file here..."
                        accept="application/pdf,application/zip,image/jpeg"></b-form-file>
                    <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div>
                    <b-button @click="file = null" v-if="Boolean(file)">Reset</b-button>
                    <hr>
                    <b-form-group id="input-group-1" label="TAG" label-for="tag-1" description="Insert a TAG" >
                        <b-form-input id="tag-1" v-model="tag" type="text" placeholder="TAG" ></b-form-input>
                    </b-form-group>
                </b-form>
            </b-container>
        </b-modal>
        <b-card title="Attachments">
            <AgGridVue :style="`width: calc(100% - 0px); height: ${height}`" class="ag-theme-alpine" :columnDefs="columnDefs" :rowData="documents" :defaultColDef="defaultColDef"
                :suppressColumnVirtualisation="false" @first-data-rendered="onFirstDataRendered" @grid-ready="onGridReady" @row-double-clicked="onRowDoubleClicked">
            </AgGridVue>
            <b-button v-if="!noAdd" @click="uploadFile()" type="submit" variant="primary"> UPLOAD A NEW FILE </b-button>
        </b-card>
    </div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);

export default {
    name: "Documents",
    components: {
        AgGridVue,
    },
    data: function () {
        return {
            mimeDoc: null,
            file: null,
            tag: null,
            addFileDlg: false,
            previewDlg: false,
            gridApi: null,
            columnApi: null,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
            },
            columnDefs: [
                // { headerName: "Download", field: "id", cellRenderer: () => { return `<div style="width: 100%;cursor:pointer;">&#x21E9;</div>` } },
                { headerName: "TAG", field: "tag", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Name", field: "name", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Type", field: "mime", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Upload Date", field: "ts", cellClass: 'ag-left-aligned-cell', filter: 'agDateColumnFilter', cellRenderer: this.dateFormatter, filterParams: { buttons: ['reset', 'apply'] } },
                { headerName: "Uploaded By", field: "uploadedby", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, sort: { direction: 'desc', priority: 0 }, },
            ],
            documents: [],
        }
    },
    props: {
        height: { type: String, default: "calc(100vh - 750px)" },
        noAdd: { type: Boolean, default: false },
        actionid: { type: Number, default: null },
    },
    watch: {
        actionid: {
            handler: async function (val) {
                console.log("actionid changed", val)
                await this.getDocuments()
            },
            immediate: true
        },
    },
    async mounted() {
        console.log("machine", this.machine)
        await this.getDocuments()
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
        issueid(){
            return this.$store.getters.issue ? this.$store.getters.issue.id : null
        },
        link() {
            console.log("link")
            return API.getAttachLink(this.machine.codice, this.file, this.issueid, this.actionid)
        },
    },
    methods: {
        async getDocuments(){
            console.log("getDocuments", this.section, this.machine.codice, this.issueid)
            this.documents = await API.getDocuments(this.section, this.machine.codice, this.issueid, null);
            this.documents = this.documents.map((i) => ({ ...i, ts: new Date(i.ts) }))
        },
        uploadFile() {
            console.log("uploadFile")
            this.addFileDlg = true
        },
        async onSubmitDocument() {
            let code = this.machine.codice
            console.log("onSubmitDocument", code, this.issueid)

			const formData = new FormData()
			formData.append('upload', this.file)
            formData.append('code', code)
            formData.append('issueid', this.issueid)
            // formData.append('actionid', this.actionid) // 20250821: allegati solo per issue
            formData.append('status', this.section)
            formData.append('tag', this.tag)
			await API.uploadDocument(formData)

            // this.gridApi.redrawRows()
            await this.getDocuments()
            this.addFileDlg = false
        },
        onResetIssue() {
            console.log("onResetIssue")
            this.addFileDlg = false
        },
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
        async onRowDoubleClicked(params) {
            console.log("rowDoubleClicked2", params.data)
            this.mimeDoc = params.data.mime
            this.file = params.data.name
            console.log("rowDoubleClicked2", this.link)
            if(params.data.mime == 'application/pdf'){ 
                window.open(this.link, '_blank')
            } else if(params.data.mime.includes('zip')){
                const a = document.createElement("a");
                console.log("link3", this.file)
                const link = this.link;
                a.style.display = "none";
                a.href = link;
                a.download = this.file
                document.body.appendChild(a);
                a.click();
            } else {
                this.previewDlg = true
            }
        },
        onGridReady(params) {
            console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
        },
        // eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
        },

    }
}

</script>
<style>
div.documents button {
    background-color: #9a240d !important;
    border-color: #9a240d !important;
    margin-bottom: 10px;
    position: absolute;
    top: 15px;
    right: 20px;
    font-size: smaller;
}
div.documents button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.documents button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}

.ag-left-aligned-cell {
    text-align: left;
}
</style>
